import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import styles from './styles.module.scss';

const LOGO_TITLE = 'Логотип Культура.РФ. Переход на главную страницу';

const Logo = ({ logoRef, tabIndex }) => (
	<a
		aria-label={LOGO_TITLE}
		className={styles.link}
		href="/"
		ref={logoRef}
		tabIndex={tabIndex}
		title={LOGO_TITLE}
	>
		<svg viewBox="0 0 98 30" className={styles.icon}>
			<Icon icon="logo" className={styles.icon} />
			<path
				d="M8.048 29H0.96V17.8H3.152V27.048H8.048V29ZM9.40275 17.8H11.5948V29H9.40275V17.8ZM17.4213 24.376L17.7093 26.28H17.7893L18.1093 24.36L20.2533 17.8H22.5573L18.3973 29.08H16.8293L12.6372 17.8H15.1813L17.4213 24.376ZM23.3663 17.8H30.0063V19.752H25.5583V22.36H29.6063V24.312H25.5583V27.048H30.0863V29H23.3663V17.8Z"
				fill="url(#logo-gradient)"
			/>
			<defs>
				<linearGradient
					id="logo-gradient"
					x1="4.85821"
					y1="19"
					x2="32.9269"
					y2="15.3925"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#7400E9" />
					<stop offset="0.797657" stopColor="#65C8FF" />
				</linearGradient>
			</defs>
		</svg>
	</a>
);

Logo.propTypes = {
	logoRef: PropTypes.object,
	tabIndex: PropTypes.number
};

export default React.memo(Logo);
